import { useGetAllSellOnTheGoFareConfigurationTariffParameters } from '@/hooks/data/masterDataHook';
import { Select, SelectProps } from 'antd';
import React from 'react';

interface Props extends SelectProps<any> {}
export default function FareConfigurationsTariffParamsInput({ ...props }: Props) {
  const { data, isLoading } = useGetAllSellOnTheGoFareConfigurationTariffParameters();

  return (
    <Select
      maxTagCount="responsive"
      allowClear
      loading={isLoading}
      {...props}
      filterOption={(input, option) => {
        return (option?.children as any)?.toLowerCase().includes(input.toLowerCase());
      }}
      showSearch={true}
    >
      {data?.map(c => {
        return (
          <Select.Option key={c.id} value={c.id}>
            {`[${c.code}] ${c.name}`}
          </Select.Option>
        );
      })}
    </Select>
  );
}
